class FitroomMegaMenu {
  constructor(menu) {
    this.menu = menu;
    this.triggers = [...menu.querySelectorAll('[data-fitroom-menu-trigger]')];
    this.panels = [...menu.querySelectorAll('[data-fitroom-product-panel]')];
    this.defaultKey = this.triggers[0]?.dataset.fitroomMenuTrigger;

    if (!this.defaultKey || this.panels.length === 0) return;

    this.triggers.forEach((trigger) => {
      const key = trigger.dataset.fitroomMenuTrigger;
      trigger.addEventListener('pointerenter', () => this.activate(key));
      trigger.addEventListener('focusin', () => this.activate(key));
    });

    this.menu.addEventListener('pointerleave', () => this.activate(this.defaultKey));
    this.menu.addEventListener('focusout', (event) => {
      if (!this.menu.contains(event.relatedTarget)) this.activate(this.defaultKey);
    });

    this.activate(this.defaultKey);
  }

  activate(key) {
    this.triggers.forEach((trigger) => {
      trigger.dataset.active = String(trigger.dataset.fitroomMenuTrigger === key);
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.fitroomProductPanel !== key;
    });
  }
}

const initializeFitroomMegaMenus = (root = document) => {
  root.querySelectorAll('.fitroom-mega-menu').forEach((menu) => {
    if (menu.dataset.productSwitcherReady === 'true') return;
    menu.dataset.productSwitcherReady = 'true';
    new FitroomMegaMenu(menu);
  });
};

initializeFitroomMegaMenus();

document.addEventListener('shopify:section:load', (event) => {
  initializeFitroomMegaMenus(event.target);
});
